<nav class="navbar fixed-top navbar-expand-lg navbar-dark bg-dark active" *ngIf="currenUser">

    <a class="navbar-brand" href="#">
        <img src="assets/img/A-64.png" width="30" height="30" alt="">
    </a>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
            <li class="nav-item" routerLinkActive="active">
                <a class="nav-link" [routerLink]="['home']">Principal</a>
            </li>
            <li class="nav-item" routerLinkActive="active">
                <a class="nav-link" [routerLink]="['document']">Documentos</a>
            </li>
            <li class="nav-item" routerLinkActive="active">
                <a class="nav-link" [routerLink]="['businesspartner']">Socios</a>
            </li>
            <!-- <li class="nav-item" routerLinkActive="active" *ngIf="currenUser.UserName == 'sys@clavisco.com'">
                <a class="nav-link" [routerLink]="['sapconfig']">SAP Config.</a>
            </li>
            <li class="nav-item" routerLinkActive="active" *ngIf="currenUser.UserName == 'sys@clavisco.com'">
                <a class="nav-link" [routerLink]="['companyconfig']">Compañia Config.</a>
            </li> -->
            <li class="nav-item" routerLinkActive="active">
                <a class="nav-link" (click)="logout()">Logout.</a>
            </li>
        </ul>

    </div>
    <div style="color:white"> 
        <span class="fa fa-user" aria-hidden="true">   {{currenUser.UserName}}</span>
    </div>
</nav>